import type { RouteRecordRaw } from 'vue-router'

import { masterPPScale } from './middleware/masterPPScale'
import { redirectInvalidUUID } from './middleware/redirectInvalidUUID'
import { PRODUCT } from './route-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('./pages/ProductProxy.vue'),
      name: PRODUCT.HOME,
      path: 'p/:slugV2/:uuid',
      meta: {
        middleware: [redirectInvalidUUID],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    {
      component: () => import('./pages/ProductProxy.vue'),
      name: PRODUCT.MASTER_PP,
      path: 'p/:slug',
      meta: {
        middleware: [masterPPScale],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    {
      component: () =>
        import(
          './components/CustomizationFunnel/components/VisibleByVerizonDrawer/components/VisibleByVerizonDrawerBody/VisibleByVerizonDrawerBody.vue'
        ),
      name: PRODUCT.VISIBLE_BY_VERIZON_DRAWER,
      path: 'p/drawers/visible-by-verizon',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import(
          './components/CustomizationFunnel/components/ProcessorModal/ProcessorModalBody/ProcessorModalBody.vue'
        ),
      name: PRODUCT.PROCESSOR_DRAWER,
      path: 'p/drawers/processor',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import(
          './components/ReassuranceItems/components/ItemObsoleteComputer/components/ObsoleteComputerModalBody/ObsoleteComputerModalBody.vue'
        ),
      name: PRODUCT.OBSOLETE_DRAWER,
      path: 'p/drawers/obsolete',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      name: PRODUCT.EXTERNAL_PAGE_VERIFIED_REFURBISHED,
      path: '/:locale/quality',
      component: () =>
        import(
          '@backmarket/nuxt-layer-base/components/ExternalPagePlaceholder/ExternalPagePlaceholder.vue'
        ),
      meta: {
        disableClientSideNavigation: () => true,
        owners: ['bot-squad-product-page-front'],
      },
    },
  ]
}
